export default {
  "sending_service.columns.sent_at": "Lähetetty",
  "sending_service.columns.type": "Tyyppi",
  "sending_service.columns.document_number": "Numero",
  "sending_service.columns.method": "Tapa",
  "sending_service.columns.status": "Tila",
  "sending_service.columns.recipient": "Vastaanottaja",
  "sending_service.columns.recipient_name": "Vastaanottajan nimi",
  "sending_service.columns.subject": "Aihe",
  "sending_service.columns.sender": "Lähettäjä",
  "sending_service.columns.error": "Alkuperäinen virhetieto",
  "sending_service.columns.message_id": "Viestin tunnus",
  "sending_service.document_types.invoice": "Lasku",
  "sending_service.document_types.report": "Raportti",
  "sending_service.document_types.notification": "Ilmoitus",
  "sending_service.methods.email": "Sähköposti",
  "sending_service.methods.einvoice": "E-lasku / Verkkolasku",
  "sending_service.methods.unknown": "Ei tallennettu",
  "sending_service.methods.letter": "Kirje",
  "sending_service.statuses.in_queue": "Jonossa",
  "sending_service.statuses.sent": "Lähetetty",
  "sending_service.statuses.processed": "Käsitelty",
  "sending_service.statuses.deferred": "Viivästetty",
  "sending_service.statuses.delivered": "Toimitettu",
  "sending_service.statuses.bounced": "Palautunut",
  "sending_service.statuses.blocked": "Estetty",
  "sending_service.statuses.dropped": "Hylätty",
  "sending_service.statuses.spam": "Roskaposti",
  "sending_service.statuses.failed": "Epäonnistui",
  "sending_service.statuses.uncertain": "Epävarma",
};
